// src/features/customers/components/CustomerList.tsx
import type { Customer } from '../customer.types';
import { CustomerRow } from './CustomerRow';

interface CustomerListProps {
  customers: Customer[];
}

export function CustomerList({ customers }: CustomerListProps) {
  if (customers.length === 0) {
    return (
      <p className="px-5 py-6 text-center text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">
        مشتری‌ای یافت نشد.
      </p>
    );
  }

  return (
    <div className="divide-y divide-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))]">
      {customers.map((customer) => (
        <CustomerRow key={customer.id} customer={customer} />
      ))}
    </div>
  );
}
